module.exports = __webpack_public_path__ + "img/gargoyle_voellerei.f640942b.png";